import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpParams} from '@angular/common/http';
import {ExpertiseArea} from '../../types/person/expertise-area';
import {ExpertiseAreaGetResponse} from '../../types/person/expertise-area-get-response';
import {BaseRestService} from '../common/BaseRestService';
import {SystemType} from '../../types/common/system-type';


@Injectable()
export class ExpertiseAreaRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('expertise-areas');
  }

  getExpertiseAreas(size: number, page: number, name: string): Observable<ExpertiseAreaGetResponse> {
    const params = {
      params: new HttpParams()
        .set('type', SystemType.DIRECTORY)
        .set('size', String(size))
        .set('page', String(page))
        .set('name', name)
    };
    return this.http.get<ExpertiseAreaGetResponse>(this.getEndpoint(), params);
  }

  create(area) {
    return this.http.post<ExpertiseArea>(this.getEndpoint(), area);
  }

  update(area) {
    return this.http.put<ExpertiseArea>(this.getEndpoint([String(area.id)]), area);
  }

  delete(area) {
    return this.http.delete<ExpertiseArea>(this.getEndpoint([String(area.id)]));
  }
}
